module.exports = __webpack_public_path__ + "static/img/wechat_code3.5a40cb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_code3.jpg
// module id = RW7Y
// module chunks = 13